var AddToFavouritesDialogueController = (function () {
    function AddToFavouritesDialogueController($location, favouritesService) {
        this.$location = $location;
        this.favouritesService = favouritesService;
    }
    AddToFavouritesDialogueController.prototype.getActualTemplateContent = function () {
        if (this.pageType === 'search') {
            return 'compatibilityguide/ng-templates/feature/favourites/addsearchresult';
        }
        return 'compatibilityguide/ng-templates/feature/favourites/addsolution';
    };
    AddToFavouritesDialogueController.prototype.finishLoading = function () {
        this.contentLoaded = true;
    };
    AddToFavouritesDialogueController.prototype.saveFavourite = function (submitEvent) {
        if (submitEvent) {
            submitEvent.preventDefault();
        }
        if (this.isSaved) {
            return;
        }
        if (this.pageType === 'search') {
            this.favouritesService.addSearchResult(this.favouriteName, this.$location.url());
        }
        else {
            this.favouritesService.addSolution(this.favouriteName, this.thirdPartyDevicesNames, this.targetUrl || this.$location.url(), this.group.images[0]);
        }
        if (this.onAfterSubmit) {
            this.onAfterSubmit();
        }
        else {
            this.isSaved = true;
            this.isRemoved = false;
            this.showRemoveButton = true;
        }
    };
    AddToFavouritesDialogueController.prototype.removeFavourite = function () {
        if (this.isRemoved) {
            return;
        }
        this.favouritesService.remove(this.targetUrl || this.$location.url());
        if (this.onAfterSubmit) {
            this.onAfterSubmit();
        }
        else {
            this.isRemoved = true;
            this.isSaved = false;
        }
    };
    AddToFavouritesDialogueController.prototype.onInputKeyPress = function (keyEvent) {
        if (keyEvent.which !== 13) {
            return;
        }
        this.saveFavourite();
    };
    AddToFavouritesDialogueController.prototype.$onInit = function () {
        var jabraProductName;
        this.andTranslation = this.andTranslation || ', ';
        this.thirdPartyDevices = this.thirdPartyDevices || [];
        if (this.thirdPartyDevices.length === 0) {
            return;
        }
        this.favouriteName = this.favouritesService.getFavouriteName(this.targetUrl || this.$location.url());
        jabraProductName = this.group ? this.group.productName : '';
        this.thirdPartyDevicesNames = this.joinWithAnd(this.thirdPartyDevices.map(function (device) { return device.manufacturer + ' ' + device.name; }));
        if (this.favouriteName === undefined) {
            this.favouriteName = this.pageType === 'search' ? this.thirdPartyDevicesNames : jabraProductName;
        }
    };
    AddToFavouritesDialogueController.prototype.joinWithAnd = function (names) {
        if (names.length === 1) {
            return names[0];
        }
        else {
            return names.slice(0, -1).join(', ') + ' ' + this.andTranslation + ' ' + names.slice(-1);
        }
    };
    AddToFavouritesDialogueController.$inject = ['$location', 'favouritesService'];
    return AddToFavouritesDialogueController;
}());
export var AddToFavouritesDialogueComponent = {
    bindings: {
        andTranslation: '<?',
        contentLoaded: '=',
        group: '<?',
        onAfterSubmit: '&?',
        pageType: '<?',
        showRemoveButton: '<?',
        targetUrl: '<?',
        thirdPartyDevices: '<',
    },
    controller: AddToFavouritesDialogueController,
    template: '<div ng-include="$ctrl.getActualTemplateContent()" onload="$ctrl.finishLoading()"></div>',
};
